export default {
      id: "circle__stop-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__stop",
      toString: function () {
        return this.url;
      }
    }